import moment from "moment";

export class StopWatchService {
  constructor(API) {
    'ngInject';
    this.API = API;
    this.counters = {
      normal: {
        active: true,
        running: false,
        hours: 0,
        minutes: 0,
        seconds: 0,
        start: null,
        startWithInterrupt: null
      },
      interrupt: {
        active: true,
        running: false,
        hours: 0,
        minutes: 0,
        seconds: 0,
        start: null
      }
    };
  }

  pad0(value) {
    // console.log('value', value)
    let result = value.toString();
      if (result.length < 2) {
        result = '0' + result;
      }
      return result;
  }

  calculate(counter) {
    const timeNow = moment();
    const duration = moment.duration(timeNow.diff(counter.startWithInterrupt || counter.start, 'seconds'), 's');
    counter.seconds = duration.seconds();
    counter.minutes = duration.minutes();
    counter.hours = duration.hours();
  }

  setNewCounterTime(counter, newTime) {
    counter.seconds = newTime._data.seconds;
    counter.minutes = newTime._data.minutes;
    counter.hours = newTime._data.hours;
  }

  step(counter) {
    if (!counter.running) return;
    this.calculate(counter);
  }

  startCounter(counter) {
    counter.running = true;
    this.watch = setInterval(() => this.step(counter), 1000);
  }

  stopCounter(counter) {
    counter.running = false;
    clearInterval(this.watch);
  }

  stopAndclearCounter(counter) {
    counter.running = false;
    clearInterval(this.watch);
    counter.hours = 0;
    counter.minutes = 0;
    counter.seconds = 0;
    counter.start = null;
    counter.startWithInterrupt = null;
  }
}
